import { Brand } from '../types/brand'
import { http } from '../services/http'
export const fetchBrands = async (): Promise<Array<Brand>> => {
  const response = await http.get<Array<Brand>>('/v2/brands')
  return response.data
}
